import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, queryConfig } from './modules'
import { queryKycStatus } from 'store/siteConfig'
import Loading from 'components/Loading'

export default function(route) {
  const PCRTest = Loadable({
    loader: () => import('./PCRTest'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          topicPcrTestState: state.topicPcrTestState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          queryConfig,
          queryKycStatus,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/pcr-test`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <PCRTest {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
